module.exports = __webpack_public_path__ + "static/img/ban01.80dac05.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban01.jpeg
// module id = j8eE
// module chunks = 6